var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1624 27.5748L14.587 28.7425V27.2155L14.9482 26.8562H17.4766V28.6526V29.9101H14.7676L11.4265 28.473L10.1624 27.5748Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6096 27.5748L20.2753 28.7425V27.2155L19.9141 26.8562H17.3858V28.6526V29.9101H20.0947L23.4356 28.473L24.6096 27.5748Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9475 24.2515L14.5863 27.2155L15.0377 26.8562H19.7332L20.275 27.2155L19.9138 24.2515L19.1914 23.8023L15.5795 23.8922L14.9475 24.2515Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5098 4.22162L14.677 9.25154L15.6703 23.8923H19.1919L20.2755 9.25154L22.262 4.22162H12.5098Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02834 15.2695L0.5 22.5448L6.82085 22.1856H10.8842V19.0419L10.7036 12.5749L9.8006 13.2935L3.02834 15.2695Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81448 16.0778L15.2189 16.2574L14.4063 20.0298L10.8846 19.1316L7.81448 16.0778Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81448 16.1677L10.8846 19.0419V21.9161L7.81448 16.1677Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8839 19.1317L14.4958 20.0299L15.6698 23.8922L14.857 24.3412L10.8839 22.0059V19.1317Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8847 22.0059L10.1624 27.5748L14.9482 24.2515L10.8847 22.0059Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2182 16.2574L15.6698 23.8922L14.3152 19.985L15.2182 16.2574Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73103 22.0958L10.8847 22.0059L10.1624 27.5748L6.73103 22.0958Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48655 30L10.1618 27.5748L6.73047 22.0958L0.5 22.5448L2.48655 30Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6771 9.2514L10.7944 12.4849L7.81448 16.0777L15.2189 16.3473L14.6771 9.2514Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1624 27.5748L14.9482 24.2515L14.587 27.1258V28.7425L11.3363 28.1137L10.1624 27.5748Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6096 27.5748L19.9141 24.2515L20.2753 27.1258V28.7425L23.526 28.1137L24.6096 27.5748Z",
    fill: "#DFCEC3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2318 17.8742L14.2251 19.9401L10.7034 19.0419L13.2318 17.8742Z",
    fill: "#393939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39565 0.00012207L14.6762 9.25151L12.5994 4.22159L2.39565 0.00012207Z",
    fill: "#E88F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39604 0L0.770676 4.94011L1.67365 10.3293L1.04157 10.6886L1.94455 11.497L1.22216 12.1257L2.21544 13.0239L1.58336 13.5628L3.02812 15.3592L9.80046 13.2934C13.1114 10.6587 14.7367 9.31135 14.6765 9.25147C14.6163 9.19159 10.5228 6.10777 2.39604 0Z",
    fill: "#8E5A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7424 15.2695L34.2707 22.5448L27.9499 22.1856H23.8865V19.0419L24.0671 12.5749L24.9701 13.2935L31.7424 15.2695Z",
    fill: "#F89D35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9568 16.0778L19.5524 16.2574L20.365 20.0298L23.8867 19.1316L26.9568 16.0778Z",
    fill: "#D87C30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9568 16.1677L23.8867 19.0419V21.9161L26.9568 16.1677Z",
    fill: "#EA8D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8874 19.1317L20.2755 20.0299L19.1016 23.8922L19.9143 24.3412L23.8874 22.0059V19.1317Z",
    fill: "#F89D35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8871 22.0059L24.6095 27.5748L19.914 24.3412L23.8871 22.0059Z",
    fill: "#EB8F35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5531 16.2574L19.1015 23.8922L20.4561 19.985L19.5531 16.2574Z",
    fill: "#EA8E3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0408 22.0958L23.8871 22.0059L24.6095 27.5748L28.0408 22.0958Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2842 30L24.6089 27.5748L28.0402 22.0958L34.2707 22.5448L32.2842 30Z",
    fill: "#EB8F35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0942 9.2514L23.9769 12.4849L26.9568 16.0777L19.5524 16.3473L20.0942 9.2514Z",
    fill: "#E8821E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5391 17.8742L20.5458 19.9401L24.0675 19.0419L21.5391 17.8742Z",
    fill: "#393939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3751 0.00012207L20.0946 9.25151L22.1713 4.22159L32.3751 0.00012207Z",
    fill: "#E88F35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3747 0L34 4.94011L33.0971 10.3293L33.7292 10.6886L32.8262 11.497L33.5486 12.1257L32.5553 13.0239L33.1874 13.5628L31.7426 15.3592L24.9703 13.2934C21.6593 10.6587 20.034 9.31135 20.0942 9.25147C20.1544 9.19159 24.2479 6.10777 32.3747 0Z",
    fill: "#8E5A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.958170e90d20e31fb6cd3c9a14838e6d.svg";
export { ForwardRef as ReactComponent };